import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";

const ContactUsStatusModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
}) => {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setSelectedData({ ...data, [name]: value });
  };

  // // handle Validation
  // const validateForm = () => {
  //   let newErrors = ValidateSchema(data, AddCustomURLSchema);
  //   setErrors(newErrors);
  //   if (Object.keys(newErrors).length) return false;
  //   return true;
  // };

  const handleAddUrl = async (e) => {
    handleSaveShowModal(data);
  };

  // Handle Update
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
          setErrors({});
        }}
        className={`customModal`}
        size="sm"
      >
        <Modal.Header className="justify-content-between d-flex">
          <h5 className="title mb-0">Change Status</h5>
          {/* <div className="modalGradientCircle"></div> */}
          <MdClose
            onClick={() => {
              handleCloseModal();
              setErrors({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        <>
          <Modal.Body>
            <div>
              <div className="form-group">
                <label className="form-label">Status</label>
                <div className="input-group globalInputWithIcon">
                  <select
                    className="form-select form-control"
                    name="status"
                    value={data.status}
                    onChange={handleChange}
                  >
                    <option value="pending">Pending</option>
                    <option value="in_progress">In Progress</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
                <span className="errorText">{errors.status}</span>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <div className={classes.btnWrapper}>
              <Button
                variant="outline-primary"
                onClick={() => {
                  handleCloseModal();
                  setErrors({});
                }}
              >
                Cancel
              </Button>

              <Button onClick={handleAddUrl} variant="primary">
                Save
              </Button>
            </div>
          </Modal.Footer>
        </>
      </Modal>
    </>
  );
};

export default ContactUsStatusModal;
